import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Group, Text } from "@mantine/core";
import { IconRefresh, IconTrash } from "@tabler/icons-react";
import { deleteRunPodJob, fetchRunPodJobs, retryRunPodJob } from "../api/runpod";
import { formatDuration } from "../lib/format";
import DateGroupedGallery from "../components/gallery/DateGroupedGallery";
import GalleryCard from "../components/gallery/GalleryCard";
import { GENERATOR_VIEWS, Page, StatusBadge, ViewSwitch } from "../components/ui";

export default function GalleryServerlessPage() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);

  return (
    <Page
      title="Gallery"
      description={total > 0 ? `Serverless · ${total}` : "Serverless"}
      actions={<ViewSwitch base="/gallery" options={GENERATOR_VIEWS} />}
    >
      <DateGroupedGallery
        fetchPage={fetchRunPodJobs}
        emptyMessage="No serverless jobs yet"
        onTotal={setTotal}
        renderItem={(job, { replace, remove }) => (
          <GalleryCard
            key={job.id}
            src={job.inputBlobUrl ?? ""}
            alt={job.runPodJobId}
            onOpen={() => navigate(`/gallery/serverless/${job.id}`)}
            badge={<StatusBadge status={job.status} size="sm" />}
            caption={
              <>
                <Text size="xs" c="dimmed" ff="monospace" lineClamp={1}>
                  {job.runPodJobId}
                </Text>
                <Text size="xs" fw={500} lineClamp={1} c={job.outputFileName ? undefined : "dimmed"}>
                  {job.outputFileName ?? "No output file"}
                </Text>
                <Group gap={8} wrap="nowrap">
                  <Text size="xs" c="dimmed">
                    Q {formatDuration(job.delayTimeMs)}
                  </Text>
                  <Text size="xs" c="dimmed">
                    P {formatDuration(job.executionTimeMs)}
                  </Text>
                </Group>
              </>
            }
            actions={[
              {
                label: "Retry",
                icon: <IconRefresh size={14} />,
                disabled: job.status !== "FAILED",
                onClick: () => void retryRunPodJob(instance, job.id).then(replace),
              },
              {
                label: "Delete",
                icon: <IconTrash size={14} />,
                color: "red",
                onClick: () => void deleteRunPodJob(instance, job.id).then(() => remove(job.id)),
              },
            ]}
          />
        )}
      />
    </Page>
  );
}
